import API from '../api/apiUtils/api2';
import { ExtHubRequest } from '../authConfig';

const api = new API({
  url: `${process.env.REACT_APP_EXTHUB_DOMAIN}/api/AgentPortalAgentDashboard`,
  scopes: ExtHubRequest,
});

api.createEntities([
  { name: 'GetProducerHeirarchyByProducer' },
  { name: 'GetProducerAlternatesByID' },
  { name: 'GetProducerAlternates' },
  { name: 'GetReportDashboard' },
  { name: 'GetConventionReport' },
]);

const GetProducerAlternates = (body) => api.endpoints.GetProducerAlternates.post(body);
const GetProducerHeirarchy = (body) => api.endpoints.GetProducerHeirarchyByProducer.post(body);
const GetProducerAlternatesByID = (producerID, isAdmin) =>
  api.endpoints.GetProducerAlternatesByID.postMultipleQueryString([
    {
      queryParam: 'ProducerID',
      queryVal: producerID,
    },
    {
      queryParam: 'isadmin',
      queryVal: isAdmin,
    },
  ]);
const GetProducerAlternatesByIDAsync = (producerID, isAdmin) =>
  api.endpoints.GetProducerAlternatesByID.postMultipleQueryString([
    {
      queryParam: 'ProducerID',
      queryVal: producerID,
    },
    {
      queryParam: 'isadmin',
      queryVal: isAdmin,
    },
  ]);
const GetReportDashboard = (producerID) =>
  api.endpoints.GetReportDashboard.postMultipleQueryString([
    {
      queryParam: 'ProducerID',
      queryVal: producerID,
    },
  ]);
const GetConventionReport = (producerID) =>
  api.endpoints.GetConventionReport.postMultipleQueryString([
    {
      queryParam: 'ProducerID',
      queryVal: producerID,
    },
  ]);

export {
  GetProducerHeirarchy,
  GetProducerAlternatesByID,
  GetProducerAlternatesByIDAsync,
  GetProducerAlternates,
  GetReportDashboard,
  GetConventionReport,
};
